"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TriggerAiEventHandlerActivator = exports.TriggerAiEventHandlerArgs = void 0;
const EventHandlerType_1 = require("../EventHandlerType");
const Registries_1 = require("../../state/Registries");
class TriggerAiEventHandlerArgs {
    constructor(aiId) {
        this.aiId = aiId;
        this.__type = EventHandlerType_1.EventHandlerType.TriggerAi;
        this.__typeName = "TriggerAi";
    }
}
exports.TriggerAiEventHandlerArgs = TriggerAiEventHandlerArgs;
let TriggerAiEventHandlerActivator = class TriggerAiEventHandlerActivator {
    activate(sequence, container, handler, e) {
        if (!container.hasAi(handler.args.aiId)) {
            return;
        }
        const ai = container.getAi(handler.args.aiId);
        Registries_1.Ai.getItem(ai.__typeName).handleEvent(sequence, container, ai, e);
    }
};
TriggerAiEventHandlerActivator = __decorate([
    Registries_1.EventHandlers.register(EventHandlerType_1.EventHandlerType.TriggerAi)
], TriggerAiEventHandlerActivator);
exports.TriggerAiEventHandlerActivator = TriggerAiEventHandlerActivator;
